<template>

    <div class="container">
        
        <back :href="route('admin.suppliers.index')" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Payment Methods') }}</h1>
            <div class="">

            </div>
        </div>

        <form @submit.prevent="form.post(route('admin.suppliers.payment-methods.store', supplier))">

            <ul class="list-group mb-4">
                <li class="list-group-item" v-for="paymentMethod in form.payment_methods">
                    <div class="row">
                        <div class="col-sm-4">
                            <switch-input v-model="paymentMethod.enabled" :label="paymentMethod.name" />
                        </div>
                        <div class="col-sm-8">
                            <textarea class="form-control" v-model="paymentMethod.notes" :placeholder="__('Notes')"></textarea>
                        </div>
                    </div>
                </li>
            </ul>

            <submit-button :form="form" />

        </form>

    </div>

</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SwitchInput from '@/shared/Inputs/SwitchInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'supplier',
            'paymentMethodsBySupplier',
        ],
        components: {
            TextInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            SwitchInput,
            SubmitButton,
        },
        data() {
            return {
                form: this.$inertia.form({
                    payment_methods: this.paymentMethodsBySupplier,
                })
            }
        },
        watch: {

        },
        methods: {

        },
    }
</script>